import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { config } from '../../config';

@Injectable({
  providedIn: 'root'
})
export class StaffService {
  instructors: any = [];
  constructor(private http: HttpClient) {
    this.instructors = [];
    console.log("Instructor Service initialized!!!!!!!", this.instructors)
  }

  addInstructor(data: any, extraData?, userData?, files?): Observable<any> {
    console.log("Adding Instructors", data);
    data['userFields'] = JSON.stringify(extraData)
    data['user'] = userData
    data['files'] = files
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "instructors", data).subscribe((res: any) => {
        observer.next(res.data.ins);
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    })
  }

  retriveInstructor(data: any): Observable<any> {

    return new Observable<any>((observer) => {
      this.http.post(config.baseApiUrl + "instructors/retrive", data).subscribe((res: any) => {
        console.log("new user added", res);
        observer.next(res)
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete()
      })
    })
  }

  editInstructor(data: any): Observable<any> {
    console.log("Edit Instructors", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "instructors", data).subscribe((res: any) => {
        console.log("Edited instructor : ", res);
        observer.next(res.data.updatedInstructor);
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });

  }

  deleteInstructor(id) {
    return new Observable((observer) => {
      this.http.delete(config.baseApiUrl + "instructors?_id=" + id).subscribe((res: any) => {
        observer.next(res.data.instructors);
        // observer.complete();
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })

    })
  }

  getInstructors(flag): Observable<any> {
    console.log("Getting Instructors");
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "instructors?userType='trainer'&&flag=" + flag).subscribe((res: any) => {
        console.log("Get Instructors : ", res);
        observer.next(res.data.instructors);
        observer.complete();
      })
    });
  }
  getAllStaff(): Observable<any> {
    console.log("Getting Instructors");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "instructors").subscribe((res: any) => {
        console.log("Get Instructors : ", res);
        observer.next(res);
        observer.complete();
      })
    });
  }


  getPendingUserList(): Observable<any> {
    console.log("Getting Instructors");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "instructors/pending-users").subscribe((res: any) => {
        console.log("Get Instructors : ", res);
        observer.next(res.data);
        observer.complete();
      })
    });
  }



  approvedPendingUser(userId): Observable<any> {
    let obj = {
      documentId: userId
    }
    console.log("Getting Instructors");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "instructors/pending-users", obj).subscribe((res: any) => {
        console.log("Get Instructors : ", res);
        observer.next(res);
      }, (error) => {
        observer.error(error)
      }, () => {
        observer.complete();
      })
    });
  }

  removedOperativeUser(obj): Observable<any> {
    console.log("Getting Instructors");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.delete(config.baseApiUrl + "instructors/pending-users?_id=" + obj).subscribe((res: any) => {
        console.log("Get Instructors : ", res);
        observer.next(res);
      }, (error) => {
        observer.error(error)
      }, () => {
        observer.complete();
      })
    });
  }


  getMps(): Observable<any> {
    console.log("Getting Instructors");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "instructors?userType=mp").subscribe((res: any) => {
        console.log("Get Instructors : ", res);
        observer.next(res.data.instructors);
        observer.complete();
      })
    });
  }

  getInstructorById(instructorId): Observable<any> {
    console.log("Getting Instructors");
    let that = this;
    let flag = false;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "instructors?_id=" + instructorId + "&&flag=" + flag).subscribe((res: any) => {
        console.log("Get Instructors : ", res);
        observer.next(res.data.instructors);
        observer.complete();
      })
    });
  }

  updateProfilePhoto(data): Observable<any> {
    console.log("Getting Instructors");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "instructors/userProfile", data).subscribe((res: any) => {
        console.log("Get Instructors : ", res);
        observer.next(res.data.updatedInstructor);
        observer.complete();
      })
    });
  }

  /**
   * @param data Competeny list to be store for digital card 
   * @returns 
   */
  addMultipleCompetencies(data): Observable<any> {
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "instructors/store-competency", data).subscribe((res: any) => {
        console.log("Get Instructors : ", res);
        observer.next(res.data);
      }, (error) => {
        observer.error(error)
      }, () => {
        observer.complete();
      })
    });
  }

  archiveMultipleStaff(data: any): Observable<any> {
    console.log("Archived Staff Data", data);
    return new Observable<any>((observer) => {
      this.http.put(config.baseApiUrl + "instructors/archive", data).subscribe((res: any) => {
        console.log("Edited instructor : ", res);
        observer.next(res.data.data);
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });

  }

  // downloadSponsorPack(downloadId) {
  //   return new Observable<any>((observer) => {
  //     console.log("Observable");
  //     this.http.get(config.baseApiUrl + "forms/download_sponsorpack?_id=" + downloadId).subscribe((res: any) => {
  //       console.log("Get Instructors : ", res);
  //       observer.next(res);
  //     }, err => {
  //       observer.error(err)
  //     }, () => {
  //       observer.complete();
  //     })
  //   });
  // }

  downloadSponsorPack(downloadId, flag) {
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "forms/download_sponsorpack?_id=" + downloadId + "&&_isUser=" + flag).subscribe((res: any) => {
        console.log("Get Instructors : ", res);
        observer.next(res);
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });
  }

    getJobRoleList(): Observable<any> {
    return new Observable<any>((observer) => {
      this.http.get(config.baseApiUrl + "instructors/job-role-list").subscribe((res: any) => {
        console.log("Get Instructors : ", res);
        observer.next(res.data);
      }, error => {
        observer.error(error)
      }, () => {
        observer.complete();
      })
    });
  }
}
